export default {
  namespaced: true,
  state: {
    sales: [],
    sale: null,
    actions: [],
    archiveActions: [],
    action: null,
    categories: [],
    groups: [],
    products: [],
    meta: {},
  },
  actions: {
    GetCustomerCode({ commit, rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('setField', { name: 'customerCode', value: null });
        rootGetters.axl.post('profiles/api/customer-code/get', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'customerCode', value: response.data.customer_code });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSkuName({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'skuProduct', value: null });
      commit('setField', { name: 'skuBarcode', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/sale/get-sku-name', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'skuProduct', value: response.data.product });
              commit('setField', { name: 'skuBarcode', value: response.data.barcode });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSalesList({ commit, rootGetters }, payload) {
      return rootGetters.axl.post('sales/api/sale/list', payload)
        .then((response) => {
          commit('setField', { name: 'sales', value: response.data.sales });
          // eslint-disable-next-line no-underscore-dangle
          commit('setField', { name: 'meta', value: response.data._meta });
        });
    },
    ConfirmAction({ dispatch, rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('/actions/api/action/take-part', {
          profile_id: payload.profile_id,
          action_id: payload.action_id,
        })
          .then((response) => {
            dispatch('GetActiveActionsList', { profile_id: payload.profile_id });
            resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetProjectsList({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'legalPersonList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/sale/get-projects-list')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'projectsList', value: response.data.list });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSalesRules({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'salesRules', value: {} });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/sale/get-rules-path')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'salesRules', value: response.data.rules });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetSale({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'sale', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/sale/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'sale', value: response.data.sale });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetProductsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'products', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/product/list-products', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'products', value: response.data.products });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetActiveActionsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'actions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('actions/api/action/current-list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'actions', value: response.data.actions });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetArchiveActionsList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'archiveActions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('actions/api/action/current-list', {
          ...payload,
          archive: true,
        })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'archiveActions', value: response.data.actions });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetAction({ commit, rootGetters, dispatch }, payload) {
      dispatch('ClearAction');
      if (payload.noClearSale === undefined) {
        dispatch('ClearSale');
      }
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('actions/api/action/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'action', value: response.data.action });
              commit('setField', { name: 'categories', value: response.data.action.categories });
              commit('setField', { name: 'groups', value: response.data.action.groups });
              commit('setField', { name: 'products', value: response.data.action.products });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    ClearAction({ commit }) {
      commit('setField', { name: 'action', value: null });
      commit('setField', { name: 'categories', value: [] });
      commit('setField', { name: 'groups', value: [] });
      commit('setField', { name: 'products', value: [] });
    },
    ClearSale({ commit }) {
      commit('setField', { name: 'sale', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
    setSales(state, sales) {
      sales.forEach(item => state.sales.push(item));
    },
  },
};
